export type LocaleString = { nb?: string; en?: string }
export type Lang = 'nb' | 'en'
export const detectLang = (): Lang =>
  typeof navigator !== 'undefined' && navigator.language.startsWith('en') ? 'en' : 'nb'
